// https://vuex.vuejs.org/en/actions.html

export default {
  //
  fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          phoneNumber: user.phoneNumber,
          vid:user.claims.vid,
          photoURL:user.photoURL
        });
      } else {
        commit("SET_USER", null);
      }
    },
    fetchVendors({commit},data){
      commit("SET_VENDORS",data)
    },
    selectVid({commit},data){
      commit("SET_VID",data)
    },
}
